import logError from "commons/utils/logError";
import pathAfterLogin from "./pathAfterLogin";
export const TOKEN_KEY = "@beedookey";
export const REFRESH_TOKEN_KEY = "@beedoorefreshkey"
export const REMEMBER_ME = "@beedooremember"
export const BEEDOO_CONFIG = '@beedooconfigkey'
export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;
export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const parseJWT = (token) => {
  if (!token) return null;
  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (err) {
    logError("Auth.parseJWT", err);
    return null;
  }
};
export const login = (token, refreshToken, remember) => {
  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(REMEMBER_ME, remember);
  localStorage.removeItem("ACCEPTY_PRIVACY")
  localStorage.removeItem("NEED_NEW_PASSWORD")
  localStorage.removeItem("SUCCESS_CHANGE_PASSWORD")

  if (typeof window !== "undefined" && window.__BEEDOO_ONESIGNAL_ID__) {
    import("./notification/PushDeviceService")
      .then((m) =>
        m.default.register(
          window.__BEEDOO_ONESIGNAL_ID__,
          window.__BEEDOO_ONESIGNAL_PLATFORM__ || "unknown"
        )
      )
      .catch((err) => logError("Auth.login.pushRegister", err));
  }
};

/** @returns {Promise<void>} Callers must await before redirecting. */
export const logout = async () => {
  try {
    if (typeof window !== "undefined" && window.__BEEDOO_ONESIGNAL_ID__) {
      const m = await import("./notification/PushDeviceService");
      await m.default.unregister(window.__BEEDOO_ONESIGNAL_ID__);
    }
  } catch (err) {
    logError("Auth.logout.pushUnregister", err);
  } finally {
    localStorage.clear();
  }
};

function getSubdomain() {
  let host = window.location.host;
  let parts = host.split(".");
  let subdomain = "dev";

  if (parts.length >= 3) {
    subdomain = parts[0];
  }

  return subdomain
}

export const SUBDOMAIN = getSubdomain();
